<template lang="pug">
	div.cajaFicheros(
		ref="caja"
		@dragover="dragOverFicheros"
		@dragleave="dragLeaveFicheros"
		@drop="droppedFicheros"
		tabindex="3"
		@keydown="teclaAbajo"
		@keyup="teclaArriba"
	)
		table.table.table-striped.m-0(style="width:100%")
			tbody
				tr(
					v-for="(fichero, i) in listadoFicheros"
					:key="fichero.ID_favorito"
					:class="(seleccion.indexOf(fichero) >= 0) ? 'bg-info' : ''"
					@click="seleccionaFichero(fichero)"
					:id="'favorito-' + fichero.ID_favorito"
					draggable
					@dragstart="dragStart($event, fichero)"
					@dblclick="agregarObjeto(fichero)"
					@contextmenu="menuContextual($event, fichero)"
				)
					td.p-1(style="max-width: 0;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;") {{fichero.ObjetoDescripcion}}
					td.p-1.text-right(style="width:45px;") {{_getDuracionFisica(fichero.ObjetoDuracion)}}
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
export default {
	data () {
		return {
			ficheroActivo: null,
			indice: 0,
			teclas: {
				ctrl: false,
				shift: false
			}
		}
	},
	computed: {
		...mapGetters({
			listadoFicheros: 'organizar-emisoras/ficherosFavoritos',
			seleccion: 'organizar-emisoras/seleccionFavoritos',
			buzon: 'organizar-emisoras/buzonActivoFavoritos',
			parrilla: 'organizar-emisoras/insercionesParrilla',
			bloqueActivo: 'organizar-emisoras/bloqueActivo'
		})
	},
	methods: {
		...mapMutations({
			seleccionaFavoritos: 'organizar-emisoras/SELECCIONA_FAVORITO'
		}),
		teclaAbajo (e) {
			if (e.keyCode !== 9) {
				e.preventDefault()
				e.stopPropagation()
			}
			this.teclas.ctrl = e.ctrlKey
			this.teclas.shift = e.shiftKey
			if (e.keyCode === 40) {
				// Abajo
				this.seleccionaIndice(1)
			} else if (e.keyCode === 38) {
				// Arriba
				this.seleccionaIndice(-1)
			} else if (e.keyCode === 32) {
				if (this.seleccion.length > 0) {
					this.$emit('reproducir', this.seleccion[0].ObjetoID)
				}
			}
		},
		teclaArriba (e) {
			e.preventDefault()
			e.stopPropagation()
			this.teclas.ctrl = e.ctrlKey
			this.teclas.shift = e.shiftKey
		},
		seleccionaIndice (i) {
			const idx = this.listadoFicheros.indexOf(this.seleccion[this.seleccion.length - 1]) + i
			if (!this.listadoFicheros[idx]) {
				return
			}
			this.seleccionaFichero(this.listadoFicheros[idx])
			document.getElementById('favorito-' + this.seleccion[0].ID_favorito).scrollIntoView({block: 'end', behavior: 'instant'})
		},
		seleccionaFichero (fichero) {
			this.ficheroActivo = fichero
			this.seleccionaFavoritos({
				fichero: fichero,
				ctrl: this.teclas.ctrl,
				shift: this.teclas.shift
			})
		},
		agregarObjeto (fichero) {
			if (!this.bloqueActivo) {
				return
			}
			const datos = {
				ficheros: [fichero.ObjetoID],
				posicion: (this.parrilla.length > 0) ? this.parrilla[this.parrilla.length - 1].ProgramacionOrden + 1 : 1
			}
			console.log(datos)
			this.$store.dispatch('organizar-emisoras/programarInserciones', datos)
		},
		dragStart (e, fichero) {
			if (this.seleccion.indexOf(fichero) < 0) {
				this.seleccionaFichero(fichero)
			}
			e.dataTransfer.setData('text/json', JSON.stringify(this.seleccion))
			e.dataTransfer.setData('text/from', 'favoritos')
			e.dataTransfer.setData('text/eliminar', this.teclas.ctrl)
		},
		dragOverFicheros (e) {
			e.preventDefault()
			e.stopPropagation()
			this.$refs.caja.style.opacity = '0.6'
		},
		dragLeaveFicheros (e) {
			e.preventDefault()
			e.stopPropagation()
			this.$refs.caja.style.opacity = '1'
		},
		droppedFicheros (e) {
			e.preventDefault()
			e.stopPropagation()
			this.$refs.caja.style.opacity = '1'
			const transf = JSON.parse(e.dataTransfer.getData('text/json'))
			const from = e.dataTransfer.getData('text/from')
			const ctrl = e.dataTransfer.getData('text/eliminar')

			if (Array.isArray(transf)) {
				this.$store.dispatch('organizar-emisoras/addFicherosFavoritos', transf)

				if (from === 'parrilla' && ctrl === 'false') {
					this.$store.dispatch('organizar-emisoras/desprogramarInserciones', transf)
				}
			}
		},

		menuContextual (e, fichero) {
			e.preventDefault()
			e.stopPropagation()
			if (this.seleccion.indexOf(fichero) < 0) {
				this.seleccionaFichero(fichero)
			}
			const menu = {
				titulo: 'Favoritos',
				evento: e,
				items: []
			}

			menu.items.push({
				texto: 'Quitar de favoritos',
				icono: 'fa fa-trash',
				activo: true,
				callback: () => {
					this.quitarFavorito(fichero)
				}
			})
			this.$store.commit('contextual/mostrar', menu)
		},

		quitarFavorito (fichero) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Quitar favorito',
				mensaje: '¿Quieres quitar los favoritos seleccionados?',
				callback: acepta => {
					if (acepta) {
						this.$store.dispatch('organizar-emisoras/delFicherosFavoritos', this.seleccion.map(f => f.ID_favorito))
					}
				}
			})
		},

		_getDuracionFisica (dur) {
			let valor = dur
			let neg = (valor < 0)
			valor = (valor < 0) ? valor * -1 : valor
			let h = '00'
			let m = '00'
			let s = '00'
			let decimas = '000'
			decimas = (valor.toString().match(/\./)) ? valor.toString().split('.')[1] : '000'

			if (valor >= 3600) {
				h = Math.floor(valor / 3600)
				h = (h < 10) ? '0' + h : h
				valor = valor % 3600
			}

			if (valor >= 60) {
				m = Math.floor(valor / 60)
				m = (m < 10) ? '0' + m : m
				valor = valor % 60
			}

			s = parseInt(valor)
			s = (s < 10) ? '0' + s : s

			decimas = decimas.toString()
			while (decimas.length < 3) {
				decimas = decimas + '0'
			}

			const menos = (neg) ? '-' : ''
			return menos + '' + h + ':' + m + ':' + s
		}
	}
}
</script>
<style scoped>
	.cajaFicheros {
		flex-grow: 1;
		font-size: 0.9em;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/organizar-emisoras/vue/paginas/organizar/ficheros-favoritos.vue